<template>
    <wistia-video-group>
        <template v-slot:meta>
			<v-col cols="12" sm="4" md="3" lg="2" class="d-flex">
				<NumberColumnsTextField v-model="mValue.NumColumns" label="Number of Columns" :tooltip="numColumnsTooltip" />
			</v-col>
        </template>

		<template v-slot:Videos>
			<DraggableGroupItems
				v-model="mValue.Videos"
				items-label="Video"
				:items-style="itemsStyle"
				class="full-width"
				@add-item="addItem"
				@delete-item="deleteItem"
			>
				<template v-slot:default="{ item }">
					<v-text-field class="mt-5" label="Title" v-model="item.title"></v-text-field>
					<v-text-field class="mt-5" label="Wistia Media ID" v-model="item.video_id"></v-text-field>
					<div>
						<p class="mt-5 mb-0 body-1 font-weight-light">Text</p>
						<text-editor class="cms" v-model="item.text"></text-editor>
					</div>
					<v-text-field class="mt-7" label="Button Text" v-model="item.buttonText"></v-text-field>
					<url-selector :key="'download_selector' + item.id" v-model="item.buttonHref" label="Button Link"></url-selector>
					<v-checkbox class="mt-0" v-model="item.newWindow" label="Open in new window" false-value="_self" true-value="_blank"></v-checkbox>
				</template>
			</DraggableGroupItems>
        </template>
    </wistia-video-group>
</template>

<script>
import TextEditor from '../TextEditor.vue'
import ImageSelector from '../ImageSelector.vue'
import UrlSelector from '../UrlSelector.vue'
import WistiaVideoGroup from '@/CMS/views/ContentBlocks/WistiaVideoGroup.vue'
import NumberColumnsTextField from '@/CMS/editor/components/NumberColumnsTextField.vue'
import DraggableGroupItems from '@/CMS/editor/components/DraggableGroupItems.vue'
import { CmsGroupEditorMixin } from '@/CMS/mixins/CmsGroupMixin'

export default {
    name: 'WistiaVideoGroupEditor',
	components: {
        TextEditor,
        WistiaVideoGroup,
        UrlSelector,
        ImageSelector,
		NumberColumnsTextField,
		DraggableGroupItems,
    },
	mixins: [CmsGroupEditorMixin],
	props: {
		value: { type: Object },
	},
    data () {
        return {
			itemsName: 'Videos', // override Mixin
        }
    },
    methods: {
		reset () { // override Mixin
			const value = { ...this.mValue }
			if (typeof value.Videos === 'undefined') {
				value.Videos = [this.getNewItem()]
			}
			if (typeof value.NumColumns === 'undefined') {
				value.NumColumns = 1
			}
			value.Videos.map((video) => {
				const item = { ...video }
				if (typeof item.id === 'undefined') {
					this.counter = this.counter + 1
					item.id = this.counter
				}
				return item
			})
			this.mValue = value
        },
		getNewItem () { // override Mixin
			this.counter = this.counter + 1
			return {
				id: this.counter,
				title: '',
				video_id: '',
				text: '',
				buttonText: '',
				buttonHref: '',
				newWindow: true,
			}
		},
    },
}
</script>
